export const EVIDENCE_TYPES = {
  TICKET: "ticket",
  TICKET_VALIDATION: "ticketValidation",
  ATTACHMENT_ASSET: "attachmentAsset",
};
